
import { Brain, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { WorkoutExercise } from '@/types/workout';

interface WorkoutExerciseListProps {
  workoutExercises: WorkoutExercise[];
  currentExerciseIndex: number;
  completed: number[];
  onSelectExercise: (index: number) => void;
}

export const WorkoutExerciseList = ({
  workoutExercises,
  currentExerciseIndex,
  completed,
  onSelectExercise
}: WorkoutExerciseListProps) => {
  return (
    <Card className="glass-card sticky top-24">
      <CardHeader>
        <CardTitle className="text-xl flex items-center">
          <Brain className="h-5 w-5 mr-2 text-primary" />
          Workout Plan
        </CardTitle>
        <CardDescription>Complete all exercises</CardDescription>
      </CardHeader>
      <CardContent>
        <ul className="space-y-3">
          {workoutExercises.map((exercise, index) => (
            <li 
              key={exercise.id}
              onClick={() => onSelectExercise(index)}
              className={`flex items-center p-3 rounded-lg cursor-pointer transition-colors ${
                index === currentExerciseIndex 
                  ? 'bg-primary/10 text-primary' 
                  : 'hover:bg-secondary'
              }`}
            >
              <div className="w-6 h-6 rounded-full flex items-center justify-center mr-3 border border-current">
                {completed.includes(index) ? (
                  <CheckCircle className="h-6 w-6 text-green-500" />
                ) : (
                  <span className="text-sm">{index + 1}</span>
                )}
              </div>
              <div>
                <p className="font-medium text-sm">{exercise.title}</p>
                <p className="text-xs text-muted-foreground">{exercise.timeEstimate}</p>
              </div>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
